import { Component, EventEmitter, OnInit, OnChanges, Output, Input, SimpleChanges, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, ConfigService, MessageService } from '../../../../core';
import { periodicidadeAnual } from '../../../../shared';
import { ConfigEmpresa } from '../../../configuracoes/app/empresa';
import { ConfigAnaliseMercado } from '../../../configuracoes/app/analise-mercado';
import { isLancamentoQuantidade, isLancamentoPeso, isLancamentoValor } from '../../../../models';
import { ClienteAnaliseMercadoClassificacaoSearchLancamento } from './cliente-analise-mercado-classificacao-search-lancamento';
import { ClienteAnaliseMercadoClassificacaoSearchLancamentoOptions } from './cliente-analise-mercado-classificacao-search-lancamento-options';
import { ClienteAnaliseMercadoClassificacaoAuthGuardService } from '../services';
import { ClienteAnaliseMercadoClassificacaoLancamentoHttpService } from './services';
// import { ClienteAnaliseMercadoUnidadeNegocioOpenLancamentoAnalise } from './cliente-analise-mercado-classificacao-open-lancamento-analise';
import { ClienteAnaliseMercadoLancamento, ClienteAnaliseMercadoLancamentoCreate, ClienteAnaliseMercadoLancamentoCreateModalComponent, ClienteAnaliseMercadoLancamentoHttpService } from '../../lancamento';
import { ClienteAnaliseMercadoPerspectiva } from '../../perspectivas/cliente-analise-mercado-perspectiva';
import { ClienteAnaliseMercadoClassificacaoSearchLancamentosFilter } from './cliente-analise-mercado-classificacao-search-lancamentos-filter';

@Component({
    selector: 'sgt-cliente-analise-mercado-classificacao-lancamento',
    templateUrl: './cliente-analise-mercado-classificacao-lancamento.component.html',
    styleUrls: ['./cliente-analise-mercado-classificacao-lancamento.component.less']
})
export class ClienteAnaliseMercadoClassificacaoLancamentoComponent implements OnInit, OnChanges {
    configEmpresa: ConfigEmpresa;
    configAnaliseMercado: ConfigAnaliseMercado;

    // Configs.
    /** Se deve exibir as colunas do projetado */
    showProjetado = false;

    // Table colspan
    tableColspanQuantidade: number;
    tableColspanPeso: number;
    tableColspanValor: number;

    @Input() idClienteAnaliseMercado: number;
    @Input() idCliente: number;
    @Input() ano: number;
    @Input() perspectiva: ClienteAnaliseMercadoPerspectiva;
    // @Input() statusClienteAnaliseMercado: number;

    /** Após criar um novo lançamento de classificação na análise de mercado */
    @Output() afterCreateLancamento = new EventEmitter<ClienteAnaliseMercadoLancamento>();
    /** Emite evento para abrir a análise da classificação */
    @Output() openLancamento = new EventEmitter<ClienteAnaliseMercadoClassificacaoSearchLancamento>();
    /** Após excluir um lançamento de classificação da análise de mercado */
    @Output() afterDeleteLancamento = new EventEmitter<any>();

    isLoading: boolean;
    entities: ClienteAnaliseMercadoClassificacaoSearchLancamento[];

    /** Modal para criar um novo lançamento de classificação na análise de mercado */
    @ViewChild('createModal') createModal: ClienteAnaliseMercadoLancamentoCreateModalComponent;

    constructor(private configService: ConfigService,
                private messageService: MessageService,
                private clienteAnaliseMercadoClassificacaoAuthGuardService: ClienteAnaliseMercadoClassificacaoAuthGuardService,
                private clienteAnaliseMercadoClassificacaoLancamentoHttpService: ClienteAnaliseMercadoClassificacaoLancamentoHttpService,
                private clienteAnaliseMercadoLancamentoHttpService: ClienteAnaliseMercadoLancamentoHttpService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.configAnaliseMercado = this.configService.getAnaliseMercado();
    }

    ngOnChanges(changes: SimpleChanges) {
        // for (const propName in changes) {
        //     // Ao alterar o cliente da análise de mercado
        //     if (propName === 'idCliente') {
        //         if (!changes[propName].isFirstChange()) {
        //             // Pesquisando as unidades de negócio da análise de mercado do cliente alterado
        //             this.search()
        //                 .then(() => {})
        //                 .catch(() => {});
        //         }
        //     }
        // }
    }

    /** Verifica se o lançamento da análise é por quantidade */
    isLancamentoQuantidade(entity: ClienteAnaliseMercadoClassificacaoSearchLancamento): boolean {
        return isLancamentoQuantidade(entity?.lancamento);
    }

    /** Verifica se o lançamento da análise é por peso */
    isLancamentoPeso(entity: ClienteAnaliseMercadoClassificacaoSearchLancamento): boolean {
        return isLancamentoPeso(entity?.lancamento);
    }

    /** Verifica se o lançamento da análise é por valor */
    isLancamentoValor(entity: ClienteAnaliseMercadoClassificacaoSearchLancamento): boolean {
        return isLancamentoValor(entity?.lancamento);
    }

    /** Calcula os colspans do head table */
    private calcularTableColspans() {
        // Quantidade
        this.tableColspanQuantidade = this.calcularTableColspanQuantidade();
        // Peso
        this.tableColspanPeso = this.calcularTableColspanPeso();
        // Valor
        this.tableColspanValor = this.calcularTableColspanValor();
    }

    /** Colspans do agrupamento do head da quantidade na table */
    private calcularTableColspanQuantidade(): number {
        let colspan = 0;

        // Quantidade potencial
        colspan += this.configAnaliseMercado?.solicitarPotencial ? 1 : 0;
        // Quantidade pretendida
        colspan += 1;
        // Quantidade projetada
        colspan += this.showProjetado ? 1 : 0;
        // Quantidade realizada
        colspan += 1;

        return colspan;
    }

    /** Colspans do head do peso na table */
    private calcularTableColspanPeso(): number {
        let colspan = 0;

        // Peso potencial
        colspan += this.configAnaliseMercado?.solicitarPotencial ? 1 : 0;
        // Peso pretendido
        colspan += 1;
        // Peso projetado
        colspan += this.showProjetado ? 1 : 0;
        // Peso realizado
        colspan += 1;

        return colspan;
    }

    /** Colspans do head do valor na table */
    private calcularTableColspanValor(): number {
        let colspan = 0;

        // Valor potencial
        colspan += this.configAnaliseMercado?.solicitarPotencial ? 1 : 0;
        // Valor pretendido
        colspan += 1;
        // Valor projetado
        colspan += this.showProjetado ? 1 : 0;
        // Valor realizado
        colspan += 1;

        return colspan;
    }

    search(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.isLoading = true;
            this.entities = [];
            const filter = new ClienteAnaliseMercadoClassificacaoSearchLancamentosFilter();
            this.clienteAnaliseMercadoClassificacaoLancamentoHttpService.search(this.perspectiva.id, this.idCliente, periodicidadeAnual.id, false, null, null, null, this.ano, filter)
                .pipe(
                    take(1)
                )
                .subscribe(
                    entities => {
                        this.entities = entities;
                        this.entities?.forEach(entity => {
                            entity.options = this.createOptions(entity);
                        })

                        this.calcularTableColspans();
                        this.isLoading = false;
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao carregar a análise de mercado do cliente', error);
                        this.isLoading = false;
                        reject();
                    }
                );
        });
    }

    /** Cria as opções da classificação */
    private createOptions(entity: ClienteAnaliseMercadoClassificacaoSearchLancamento): ClienteAnaliseMercadoClassificacaoSearchLancamentoOptions {
        const options = new ClienteAnaliseMercadoClassificacaoSearchLancamentoOptions();
        // Criar lançamento da análise
        options.canCreateLancamento = this.clienteAnaliseMercadoClassificacaoAuthGuardService.canCreateLancamento(entity.id, this.idCliente, this.ano, entity.classificacoesSlug);
        // Abrir lançamento da análise
        options.canOpenLancamento = this.clienteAnaliseMercadoClassificacaoAuthGuardService.canOpenLancamento(entity.id, this.idCliente, this.ano);
        // Excluir lançamento da análise
        options.canDeleteLancamento = this.clienteAnaliseMercadoClassificacaoAuthGuardService.canDeleteLancamento(entity.id);

        return options;
    }

    /** Cria um novo lançamento de classificação na análise de mercado */
    createLancamento(entity: ClienteAnaliseMercadoClassificacaoSearchLancamento) {
        if (!entity || !entity?.options?.canCreateLancamento) {
            this.messageService.info(`Não é possível criar o lançamento para o segmento ${entity.classificacoesNome}`, 'Informação');
            return;
        }

        const entityCreate = new ClienteAnaliseMercadoLancamentoCreate(this.perspectiva.id, this.idCliente, this.ano);
        entityCreate.idGrupoClassificacao = entity.idGrupoClassificacao;
        entityCreate.classificacoesSlug = entity.classificacoesSlug;
        this.clienteAnaliseMercadoLancamentoHttpService.create(entityCreate)
            .pipe(
                take(1)
            )
            .subscribe(
                entityCreated => {
                    this.onAfterCreateLancamento(entityCreated);
                    this.messageService.success('', 'Lançamento do segmento criado com sucesso na análise de mercado');
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao criar o lançamento do segmento na análise de mercado', error);
                }
            );
    }

    /** Abre modal para criar um novo lançamento de classificação na análise de mercado */
    createLancamentoModal() {
        this.createModal?.insert(this.perspectiva, this.idCliente, this.ano);
    }

    /** Após inserir uma nova classificação na análise de mercado do cliente */
    onAfterCreateLancamento(entity: ClienteAnaliseMercadoLancamento) {
        this.afterCreateLancamento.emit(entity);

        // Carregamos novamente para atualizar as classificações
        this.search()
            .then(() => {})
            .catch(() => {});
    }

    /** Emite evento para abrir o lançamento da classificação na análise de mercado */
    openLancamentoClick(entity: ClienteAnaliseMercadoClassificacaoSearchLancamento) {
        if (!entity || !entity?.options?.canOpenLancamento) {
            this.messageService.info(`Não é possível abrir o lançamento do segmento ${entity.classificacoesNome}`, 'Informação');
            return;
        }

        this.openLancamento.emit(entity);
    }

    /** Exclui a análise e seus meses do lançamento da classificação */
    deleteLancamento(entity: ClienteAnaliseMercadoClassificacaoSearchLancamento) {
        if (!entity || !entity?.options?.canDeleteLancamento) {
            this.messageService.info(`Não é possível abrir o excluir o lançamento do segmento ${entity.classificacoesNome}`, 'Informação');
            return;
        }

        this.messageService.confirm(`Deseja realmente excluir o lançamento do segmento ${entity.classificacoesNome}?`, 'Confirme').then((result) => {
            if (result) {
                this.clienteAnaliseMercadoLancamentoHttpService.deleteClassificacao(entity.id)
                    .subscribe(
                        () => {
                            this.messageService.success('', `Lançamento do segmento ${entity.classificacoesNome} excluído com sucesso na análise de mercado`);
                            this.afterDeleteLancamento.emit();

                            // Atualizando as classificações
                            this.search()
                                .then(() => {})
                                .catch(() => {});
                        },
                        (error: ApiError) => {
                            this.messageService.error(error.message, `Erro ao excluir o lançamento do segmento ${entity.classificacoesNome} na análise de mercado`);
                        }
                    );
            }
        });
    }
}
